module.exports = __webpack_public_path__ + "notDelivered_icon.png";